import React from 'react';
import { IonIcon } from '@ionic/react';
import { getCleanGameName, getCleanThemeName, ISlotData, toCapitalizedWords } from 'common/common';
import { chevronBackOutline } from 'ionicons/icons';
import { LikeButton } from 'pages/Favorites/components/LikeButton';
import { getGameNameColor } from 'common/include';
import TextMarquee from 'components/TextMarquee';

interface SlotHeaderProps {
  slotData: ISlotData;
  onBack?: () => void;
  isProUser: boolean;
}

const SlotHeader: React.FC<SlotHeaderProps> = ({ slotData, onBack, isProUser }) => {
  const { name, gameTheme, slotNumber, displayId, denom, pop } = slotData;
  // displayId = machines.slotNumber when present; slotNumber stays mnum for LikeButton.
  const shownId = displayId || String(slotNumber);
  const subtitle = `Slot ${shownId} • ${denom} • POP ${pop}`;
  const gameNameColor = getGameNameColor(isProUser);

  return (
    <div className="header">
      <IonIcon icon={chevronBackOutline} className="icon" onClick={onBack} />
      <div className="title">
        {gameTheme && <h3>{toCapitalizedWords(gameTheme)}</h3>}
        {name && <h3>{toCapitalizedWords(getCleanThemeName(name))}</h3>}

        <h2
          style={{
            color: gameNameColor,
          }}
        >
          <TextMarquee text={toCapitalizedWords(getCleanGameName(name))} />
        </h2>
        {subtitle && <p>{subtitle}</p>}
      </div>
      <div className="icons">
        <LikeButton slotNumber={String(slotNumber)} fontSize="large" className="like-button" />
      </div>
    </div>
  );
};

export default SlotHeader;
